import store from './vuex/vuex';

const permissionConfig = [
  // Handling Pages
  { target: '/usage_reports/account', specified: ['ReadAccount'] },
  { target: '/usage_reports/account', specified: ['ModifyAccountSettings'] },
  { target: '/usage_reports/azure_subscription', specified: ['ReadAccount'] },
  { target: '/usage_reports/cross_tag', specified: ['ReadTags'] },
  { target: '/usage_reports/group', specified: ['ReadGroups'] },
  { target: '/usage_reports/group', specified: ['ModifyGroups'] },
  { target: '/usage_reports/tag', specified: ['ReadTags'] },
  { target: '/usage_reports/tag', specified: ['ModifyTags'] },
  { target: '/ri', specified: ['ReadRi'] },
  { target: '/savings_plan', specified: ['ReadSavingsPlan'] },
  { target: '/recommendation', specified: ['ReadRi', 'ReadSavingsPlan'] },
  { target: '/invoice', specified: ['ReadInvoice'] },
  { target: '/invoice', specified: ['ModifyInvoice'] },
  { target: '/settings', specified: ['ReadSettings'] },
  { target: '/settings', specified: ['ModifySettings'] },

  // Handling Functions
  { target: 'Admin', specified: ['Admin'] },

  // Read
  { target: 'ReadTags', specified: ['ReadTags'] },
  { target: 'ReadGroups', specified: ['ReadGroups'] },
  { target: 'ReadInvoice', specified: ['ReadInvoice'] },
  { target: 'ReadAccount', specified: ['ReadAccount'] },
  { target: 'ReadSettings', specified: ['ReadSettings'] },
  { target: 'ReadBillingGroup', specified: ['ReadBillingGroup'] },
  { target: 'ReadAccountSettings', specified: ['ReadAccountSettings'] },

  // { target: 'ReadTags', specified: ['ModifyTags'] },
  // { target: 'ReadGroups', specified: ['ModifyGroups'] },
  // { target: 'ReadInvoice', specified: ['ModifyInvoice'] },
  // { target: 'ReadSettings', specified: ['ModifySettings'] },
  // { target: 'ReadAccountSettings', specified: ['ModifyAccountSettings'] },

  // Write
  { target: 'ModifyTags', specified: ['ModifyTags'] },
  { target: 'ModifyGroups', specified: ['ModifyGroups'] },
  { target: 'DownloadBulk', specified: ['DownloadBulk'] },
  { target: 'ModifySettings', specified: ['ModifySettings'] },
  { target: 'DownloadReports', specified: ['DownloadReports'] },
  { target: 'ModifyBillingGroup', specified: ['ModifyBillingGroup'] },
  { target: 'ModifyAccountSettings', specified: ['ModifyAccountSettings'] },
];

export const handleByPermission = target => {
  let permissions;
  // DevTools
  const devToolsEnabled = store.state.devTools.isEnabled;
  if (devToolsEnabled) {
    permissions = store.getters['devTools/getPermissions'];
  } else {
    permissions = store.state.rbac.permissions;
  }

  // ルートユーザーの場合
  if (!permissions) return true;

  const config = permissionConfig.filter(val => val.target === target);

  if (config.length === 0) return true;

  const result = () => {
    const arr = config.map(conf => {
      if (conf) {
        const specified = conf['specified'];
        if (specified) {
          // Adminパーミッションがアタッチされている場合
          if (permissions.includes('Admin')) return true;

          // Permissionsが存在しない場合
          if (permissions.length === 0) return true;

          // Permissionsが全てマッチする場合はtrueを返す
          return specified.every(value => {
            return permissions.includes(value);
          });
        }
        return true;
      } else {
        return true;
      }
    });

    // 一つでもtrueが含まれている場合はtrueを返す
    return arr.some(v => v);
  };

  return result();
};

export const permissions = [
  'Admin',

  // Accounts
  'ReadAccount',
  'ReadAccountSettings',
  'ModifyAccountSettings',

  // Groups
  'ReadGroups',
  'ModifyGroups',

  // Tags
  'ReadTags',
  'ModifyTags',

  // RI
  'ReadRi',

  // Savings Plans
  'ReadSavingsPlan',

  // Settings
  'ReadSettings',
  'ModifySettings',

  // Billing Groups
  'ReadBillingGroup',
  'ModifyBillingGroup',

  // Invoice
  'ReadInvoice',
  'ModifyInvoice',

  // Download
  'DownloadBulk',
  'DownloadReports',
];
